import React from 'react';
import PropTypes from 'prop-types';

import { Autocomplete } from '@metarouter-private/mr-mui';
import { useChildIdSet } from '@ion/api/audit-logs/query';

import { ENTITY_LABELS } from 'app/audit-logs/entity-labels';

export default function ChildSelector({ recordRef, childType, value, onChange }) {
  const { children, loading } = useChildIdSet({ parentId: recordRef.scopeValues.id, childType });
  const selected = children.find(child => child.id === value) ?? null;

  return (
    <Autocomplete
      data-test-id="auditLogChildSelector"
      label={ENTITY_LABELS[childType].singular}
      options={children}
      getOptionLabel={child => child.name}
      value={selected}
      loading={loading}
      onChange={(_, child) => onChange(child?.id ?? null)}
    />
  );
}

ChildSelector.propTypes = {
  recordRef: PropTypes.shape({ scopeValues: PropTypes.object.isRequired }).isRequired,
  childType: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
